import React from 'react';
import StopPage from '../components/MobileDailyOperation/Stops/StopPage';

const StopGrid = ({ selectedDate }) => {
  return (
    <div>
      <StopPage selectedDate={selectedDate} /> {/* selectedDate를 Stop 컴포넌트로 전달 */}
    </div>
  );
};

export default StopGrid;
